import React, { useState } from "react";
import { useEffect } from "react";
import "./verifyAccount.scss";
import {MessageSuccess} from "../../components/messageSuccess/messageSuccess";
import { userService } from "../../services/user.service";
import {ColorStripe} from "../../components/colorStripe/colorStripe";
import {useHistory} from "react-router-dom";

export const VerifyAccount = (props) => {
  const [verify, setVerify] = useState({});
    const history = useHistory();

    useEffect(() => {
    userService
      .verifyAccount({
        UserId: props.location.search.split("userId=")[1].split("&")[0],
        Code: props.location.search.split("code=")[1],
      })
      .then((result) => setVerify(result));
  }, [props.location.search]);

  return (
    <section className="verify-account">
        <div className={"verify-account__top"}>
            <h2>Verificación de cuenta</h2>
            <ColorStripe />
        </div>
          {verify && (
              <MessageSuccess
                  title={`${
                      verify.responseCode == "00"
                          ? "¡Verificación exitosa!"
                          : "¡Error al verificar cuenta!"
                  }`}
                  description={`${
                      verify.responseCode == "00" ? "" : verify.responseMessage
                  }`}
                  isSuccess={(verify.responseCode == "00")}
                  btnText={"Ir al home"}
                  handleButtonClick={() => history.push('/home')}
              />
          )}
    </section>
  );
}